<div class="steps-wrapper">
  <gbc-page-container class="steps">
    @for (step of steps; track step; let i = $index) {
      <div class="step">
        <div class="bar" [ngClass]="{ enabled: selectedIndex === i }"></div>
        <div class="step-label" [ngClass]="{ enabled: selectedIndex === i }">
          {{ step.label }}
        </div>
      </div>
    }
  </gbc-page-container>
</div>

<gbc-page-container>
  @if (selected) {
    <div>
      <ng-container [ngTemplateOutlet]="selected.content"></ng-container>
    </div>
  }

  <footer class="stepper-navigation mb-8">
    @if (selectedIndex !== 0) {
      <button gbc-button cdkStepperPrevious class="stepper-button stepper-button--back" [disabled]="backDisabled">
        {{ backLabel }}
      </button>
    }

    @if (selectedIndex === 0) {
      <button gbc-button cdkStepperPrevious class="stepper-button stepper-button--back" (click)="exit.emit()">
        {{ backLabel }}
      </button>
    }

    @if (selectedIndex !== steps.length - 1) {
      <button gbc-button cdkStepperNext class="stepper-button" [disabled]="nextDisabled">
        {{ nextLabel }}
      </button>
    }

    @if (selectedIndex === steps.length - 1) {
      <button gbc-button class="stepper-button" (click)="done.emit()" [disabled]="doneDisabled">
        {{ doneLabel }}
      </button>
    }
  </footer>
</gbc-page-container>
